import useRouter from "common/hooks/use-router";
import { useCallback } from "react";
import CrudEdit from "common/components/Crud/CrudEdit";
import AppointmentTypeForm from "./AppointmentTypeForm";

function AppointmentType() {
  const router = useRouter();

  const id = router.query.id as string;

  const back = useCallback(() => {
    router.navigate("/appointment-types");
  }, [router]);

  return (
    <CrudEdit
      collectionName="appointment-types"
      id={id}
      Form={AppointmentTypeForm}
      onBack={back}
    />
  );
}

export default AppointmentType;
